import React, { useState } from 'react';
import {  Typography, TextField, Button, Box, Link } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import WarningIcon from '@mui/icons-material/Warning';
import API_BASE_URL from '../Constants'; // Import the base URL from Constants.js

const theme = createTheme();

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password?email=${email}`, {
        method: 'POST',
      });

      if (response.ok) {
        const data = await response.json();
        setMessage(data.message || 'Success! Check your email for further instructions.');
        setIsError(false);
      } else {
        const errorData = await response.json();
        setMessage(errorData.message || 'No associated account with that email.');
        setIsError(true);
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
      setIsError(true);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#f4f6f8',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: 400,
            padding: 3,
            backgroundColor: '#fff',
            borderRadius: 1,
            boxShadow: 3,
          }}
        >
          <Box sx={{ textAlign: 'center', marginBottom: 2 }}>
            <WarningIcon color="primary" sx={{ fontSize: 40 }} />
          </Box>
          <Typography
            component="h1"
            variant="h5"
            sx={{
              marginBottom: 2,
              fontWeight: 'bold',
              textAlign: 'center',
              color: '#1976d2',
            }}
          >
            Forgot Password
          </Typography>
          <Typography variant="body2" sx={{ marginBottom: 2, textAlign: 'center' }}>
            Enter your email and we'll send you a link to reset your password.
          </Typography>
          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <TextField
              variant="outlined"
              fullWidth
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ marginBottom: 2 }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ backgroundColor: '#4caf50', marginBottom: 2 }}
            >
              Submit
            </Button>
          </form>
          {message && (
            <Typography
              variant="body2"
              sx={{
                textAlign: 'center',
                color: isError ? 'red' : 'green',
                marginBottom: 2,
              }}
            >
              {message}
            </Typography>
          )}
          <Link href="/login" variant="body2" sx={{ textAlign: 'center', display: 'block', marginBottom: 2 }}>
            Back to Login
          </Link>
        </Box>
        <Typography variant="body2" sx={{ marginTop: 4, fontSize: 12, color: '#aaa', textAlign: 'center' }}>
          Copyright © 2024 Site Service Software Inc.
        </Typography>
      </Box>
    </ThemeProvider>
  );
};

export default ForgotPassword;
